export default {
  signUp: {
    title: '登録してグローバル環境求人を見る',
    subtitle: '新規アカウントを作成する',
    separator: 'またはSNSで新規登録',
    links: {
      termsPre: '',
      terms: '利用規約',
      termsPost: 'に同意する',
      and: 'と',
      privacy: '個人情報の取り扱い',
      privacySuffix: 'に同意したことになります。',
      loginPre: 'すでにGitTapアカウントをお持ちの場合は',
      loginPre2: 'こちらから',
      login: 'ログイン',
      loginSuffix: 'できます。',
      handlingPersonalInformation: '個人情報の取り扱い'
    },
    footer: {
      one: 'または以下のアカウントでサインイン',
      two: 'すでにGitTapアカウントをお持ちの場合は、',
      three: 'ログインできます'
    },
    form: {
      email: {
        label: 'Eメール',
        placeholder: 'メールアドレスを入力してください'
      }
    },
    create: 'アカウントを作成する',
    validation: {
      password: 'パスワードは英数字で8文字以上にする必要があります',
      required: '必須。'
    },
    success: {
      title: '認証メールが送信されました。',
      body: 'メールにある〔アカウントを認証〕ボタンをクリックしてログインしてください。',
      or: 'か',
      login: 'ログイン'
    },
    verified: {
      title: 'アカウントの認証が完了しました',
      body: '「まずはプロフィール情報をつくりましょう。」',
      failed: {
        title: '認証に失敗しました',
        body: 'URLが無効または期限切れです。',
        actionLabel: '再登録'
      }
    },
    social: {
      google: 'Googleで新規登録',
      facebook: 'Facebookで新規登録',
      linkedIn: 'LinkedInで新規登録',
      github: 'Githubで新規登録'
    },
    tokenError:
      'このURLはすでに使用されています。招待者へ新しいURL の発行を依頼してください。'
  }
}
